<template>
    <v-app id="inspire">
        <div v-if="!isAuthenticated" >
            <router-view></router-view>
        </div>
        <div v-else-if="isAuthenticated">
            <app-drawer></app-drawer>
            <app-toolbar></app-toolbar>
            <app-view></app-view>
        </div>
        <v-dialog v-model="showNotice" scrollable width="500px">
            <v-card>
                <v-card-title
                        class="headline">
                    Aviso
                </v-card-title>
                <v-card-text>
                    <p>Bienvenido al nuevo Portal de Estudiantes del ITTG.
                    </p>
                    <p>
                        Agradecemos tu interés en ayudarnos a reportar los errores que encuentres, así como las sugerencias que tengas y puedan
                        colaborar en el desarrollo y mejora continua de este portal.
                    </p>
                    <p>
                        Puedes enviar tus reportes al siguiente correo <b>appestudiantes@ittg.edu.mx</b> anexando tu Nombre, No. de Control, Descripción del problema y capturas de pantalla.
                    </p>

                    Gracias por tu participación.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green"
                            flat
                            @click="showNotice = false"
                    >
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import AppDrawer from '@/components/core/AppDrawer'
  import AppToolbar from '@/components/core/AppToolbar'
  import AppView from '@/components/core/AppView'
  import { AUTH_LOGOUT } from '@/store/mutation-types'

  export default {
    components: {
      AppView,
      AppToolbar,
      AppDrawer
    },
    created () {
      const app = this

      axios.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if ((err.request.status === 401 && err.config && !err.config.__isRetryRequest) || !app.isAuthenticated) {
            // if you ever get an unauthorized, logout the user
            app.$store.dispatch(AUTH_LOGOUT)
            app.$router.push('/login')
          }
          throw err
        })
      })
    },
    data: () => ({
      showNotice: false
    }),
    props: {
      source: String
    },
    computed: {
      ...mapGetters(['isAuthenticated'])
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue